<template>
    <div 
        :class="[
            'modal',
            theme,
            { 'is-active': isActive }
        ]"
    >
        <div class="modal-overlay" />
        <div class="modal-content">
            <div class="modal-body">
                <div 
                    v-bastards
                    v-html="bodyHtml"
                />
                <div 
                    v-if="!isCloseable"
                    class="modal-body-buttons flex flex-content-center flex-reverse"
                >
                    <button 
                        v-bastards
                        class="fs-22 btn btn-c--secondary"
                        @click="onClickCancel"
                    >
                        Pozostaw zgodę i bądź na bieżąco <i class="icon-noun_down" />
                    </button>
                    <button 
                        v-bastards
                        class="fs-22 btn btn-c--transparent"
                        @click="onClickProceed"
                    >
                        Wycofaj zgodę i zapisz zmiany <i class="icon-noun_down" />
                    </button>
                </div>
                <div 
                    v-else
                    class="modal-body-buttons"
                >
                    <a 
                        class="fs-22 btn btn-c--secondary"
                        @click="onClickProceed"
                    >
                        {{ closeLabel }} <i class="icon-noun_down" />
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isCloseable: {
            type: Boolean,
            required: false,
            default: false
        },
        closeLabel: {
            type: String,
            required: false,
            default: 'Ponów próbę'
        }
    },

    data () {
        return {
            bodyHtml: '',
            theme: '',
            isActive: false,
            onProceed: () => {},
            onCancel: () => {}
        }
    },

    methods: {
        open (bodyHtml, type = 'success', onProceed, onCancel) {
            this.theme = 'modal--' + type
            this.bodyHtml = bodyHtml
            this.isActive = true
            this.onProceed = onProceed || this.onProceed
            this.onCancel = onCancel || this.onCancel
        },

        onClickClose () {
            this.close()
        },

        close () {
            if (!this.isActive) {
                return
            }
            
            this.isActive = false 

            this.$emit('close')

            setTimeout(() => {
                this.reset()
            }, 200)
        },

        reset () {
            this.bodyHtml = ''
            this.theme = ''
        },

        onClickProceed() {
            this.onProceed()
            this.close()
        },

        onClickCancel() {
            this.onCancel()
            this.close()
        }
    }
}
</script>

<style lang="scss">
.modal {
    @include transition(.1s);
    position: fixed;
    visibility: hidden;
    width: 1280px;
    min-height: 450px;
    top: calc(50% - 225px);
    left: calc(50% - 640px);
    opacity: 0;
    z-index: 3018;

    &-overlay {
        @include position-cover-fixed();
        background-color: rgba($color-default, .75);
        z-index: -2;
    }

    &:before,
    &:after {
        content: '';
        @include transform(scaleX(.39));
        @include transition(.3s);
        background-color: $color-bg-light;
        position: absolute;
        top: 0;
        bottom: 0;
        opacity: 0;
        z-index: -1;
    }

    &:before {
        @include transform-origin(100%, 50%);
        left: 0;
        right: 50%;
    }

    &:after {
        @include transform-origin(0, 50%);
        right: 0;
        left: 50%;
    }

    &--error {
        &:before,
        &:after {
            background-color: $color-error;
        }
    }

    &--center {
        text-align: center;
    }

    &--center-small {
        min-height: 275px;
        text-align: center;

        &-error {
            text-align: center;
            min-height: 275px;

            .modal-body {
                header,
                p {
                    color: $color-default-contrast;
                }
            }

            &:before,
            &:after {
                background-color: $color-error;
            }
        }
    }

    $content-fade-delay: .25s;

    &-body {
        @include transform(translateY(-10px));
        @include transition(all .3s ease-out $content-fade-delay);
        padding: 45px 30px 25px 49px;
        opacity: 0;

        .icon-mail {
            min-width: 69px;
            margin-right: 34px;
        }

        header {
            color: $color-default;
            margin-bottom: 25px;
        }

        strong {
            font-weight: $font-weight-bold;
        }

        p {
            color: $color-default;
        }

        .bg-color-bg-primary {
            overflow: hidden;
            text-align: left;
            margin: 31px auto 0;
            padding: 20px 40px 20px;
            max-width: 618px;
        }

        &-buttons {
            margin-top: 25px;

            .btn {
                position: relative;

                [class^="icon-"] {
                    @include transform(rotate(-90deg));
                    @include transition(.100s);
                    font-size: 15px;
                    top: 30px;
                    right: 23px;
                }

                &-c--transparent {
                    color: $color-default;
                }

                &-c--secondary {
                    &:hover {
                        [class^="icon-"] {
                            color: $color-default-contrast;
                        }
                    }
                }
            }

            button {
                margin-left: 50px;
            }

            button + button {
                margin-left: 0;
            }
        }
    }

    &-close {
        @include transform(scale(.46));
        @include transition(all .2s ease-out $content-fade-delay);
        top: 5px;
        right: 5px;
        opacity: 0;
    }

    &.is-active {
        visibility: visible;
        opacity: 1;

        &:before,
        &:after {
            @include transform-none();
            opacity: 1;
        }
    }

    &.is-active & {
        &-body {
            @include transform-none();
            opacity: 1;
        }

        &-close {
            opacity: 1;
        }
    }

    @media (max-width: $screen-laptop) {
        overflow-y: auto;
        max-height: 100%;
        top: calc(50% - 230px);
        left: 15px;
        right: 15px;
        width: auto;

        &:before,
        &:after {
            position: fixed;
        }
    }

    @media (max-width: $screen-tablet) {
        top: 0;
    }

    @media (max-width: $screen-mobile-landscape) {
        min-height: none;
        min-height: unset;
        width: 100%;
        left: 0;

        &-body {
            padding: 35px 20px 35px 30px;

            img {
                display: none;
            }

            .icon-mail {
                display: none;
            }

            &-buttons {
                &.flex {
                    display: block;
                }

                button {
                    margin-left: 0;
                    
                    & + button {
                        margin-top: 25px;

                    }
                }
            }
        }
    }
}
</style>
